import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { StatusMessage, StepInstructions, PassRecipe, PlanRules, PlanPerks } from "../index";
import { PassContainer, PassWrapper, PassHeading, PassImage } from "./styles";

function prepareGuestName(userData) {
  const { firstName, lastName } = userData || { firstName: 'Unknown', lastName: 'Guest' };

  return [firstName ? firstName.trim() : 'Unknown', lastName ? lastName.trim() : 'Guest'].filter(Boolean).join(' ');
}

const PassConfirmationLayout = ({ bookedDate, code, description, highlight, name, price, totalPrice, type, payment, userData, image }) => (
  <PassContainer>
    <PassWrapper>
      <PassHeading>Confirmation</PassHeading>
      <StatusMessage status={0} message={`Thanks for purchasing with DayAxe! Your ${name} is now active`} />
      <StepInstructions steps={['Access your booking on your mobile phone.', 'Show your booking and photo ID', 'Hotel will validate']} heading='How to reserve passes' />
      <PassImage>
        <img src={`${process.env.CDN_URL}${image}`} alt="Pass confirmation" />
      </PassImage>
      <PlanRules rules={description} />
      <PlanPerks passType={type} perks={[{ title: 'Goldfriend', description: '10% OFF additional passes for friends & family, limit 2 uses per month' }]} />
      <PassRecipe code={code} bookedDate={bookedDate} highlight={highlight} price={price} totalPrice={totalPrice} name={name} payment={payment} guestName={prepareGuestName(userData)} />
    </PassWrapper>
    <script
      dangerouslySetInnerHTML={{ __html:
        `fbq('track', 'Purchase');`
      }}
    />
  </PassContainer>
);

PassConfirmationLayout.propTypes = {
  bookedDate: PropTypes.string,
  description: PropTypes.string,
  code: PropTypes.string,
  highlight: PropTypes.string,
  name: PropTypes.string,
  price: PropTypes.number,
  totalPrice: PropTypes.number,
  type: PropTypes.number,
  payment: PropTypes.instanceOf(Object),
  userData: PropTypes.instanceOf(Object),
  image: PropTypes.string,
};

const mapStateToProps = state => ({
  userData: state.user.userData,
});

export default connect(mapStateToProps)(PassConfirmationLayout);
